import { useLocation, useNavigate } from "react-router";
import { useMediaQuery } from "react-responsive";
import { 
    DesktopUnsupportedLocale,
    MobileUnsupportedLocale
} from "./components";
import { BREAKPOINTS } from "../../constants";

const UnsupportedLocaleScreen = () => {
    const navigate = useNavigate();
    const isDesktopOrLaptop = useMediaQuery({ query: BREAKPOINTS.DESKTOP })
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const locale = queryParams.get('locale');

    const getLanguageName = (locale) => {
        try {
            const displayNames = new Intl.DisplayNames(["en"], { type: "language" });
            return displayNames.of(locale);
        } catch (error) {
            return null;
        }
    }

    const handleContinueInEnglish = () => {
        navigate("/sign-in?locale=en")
    }

    const commonProps = {
        language: getLanguageName(locale),
        handleContinueInEnglish
    }

    if (isDesktopOrLaptop) {
        return <DesktopUnsupportedLocale {...commonProps} />
    }

    return <MobileUnsupportedLocale {...commonProps} />;
}

export default UnsupportedLocaleScreen;